import React from "react";
import format from "date-fns/format";
import jsPDF from "jspdf";
import printJS from "print-js";

import { NO_DATA_FOUND } from "../../../../constants";
import TemplateIcon from "../../../../components/uiElements/icons/onboardingIcons/TemplateIcon";
import { getUserData } from "../../../../utils/localStorage";
import ProfileIcon from "../../../../components/uiElements/icons/profileIcons/ProfileIcon";

const PatentNoteList = ({
  notes,
  searchedResult,
  searchValue,
  setShowModal,
  setCurrentNoteData,
  setEditMode,
  setCurrentNoteImages,
  setUnlock,
}) => {
  const fetchedNotes = notes;

  const generatePDF = (items) => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text(`Appointment Notes with Dr. ${items.doctor_first_name} ${items.doctor_last_name}`, 10, 10);
    doc.setFontSize(12);
    doc.text(`Date: ${format(new Date(items.created_at), "MMMM dd, yyyy • hh:mm a")}`, 10, 20);

    doc.text("Note Name:", 10, 30);
    doc.text(items.note_name || "-", 50, 30);

    doc.text("Chief Complaints:", 10, 40);
    doc.text(items.chief_complaint || "-", 50, 40);

    doc.text("Vitals:", 10, 50);
    doc.text(`Blood Pressure: ${items.blood_pressure || "-"}`, 20, 60);
    doc.text(`Pulse: ${items.pulse || "-"}`, 20, 70);
    doc.text(`Oxygen Saturation: ${items.oxygen_saturation || "-"}`, 20, 80);
    doc.text(`Weight: ${items.weight || "-"}`, 20, 90);
    doc.text(`Height: ${items.height || "-"}`, 20, 100);

    doc.text("Notes:", 10, 110);
    doc.text(items.notes || "-", 20, 120, { maxWidth: 180 });

    doc.text("Assessments:", 10, 140);
    doc.text(items.assessment || "-", 20, 150);

    doc.text("Plan:", 10, 160);
    doc.text(items.plan || "-", 20, 170);

    doc.text("Additional Comment:", 10, 180);
    doc.text(items.additional_comment || "-", 20, 190);

    doc.save(`${items.note_name || "Appointment_Notes"}.pdf`);
  };

  return (
    <>
      {fetchedNotes?.length === 0 ? (
        <p className="content-center m-auto not-found-image">
          <img
            src={NO_DATA_FOUND}
            width={366}
            height={300}
            alt="requests-not-found"
          />
        </p>
      ) : (
        <div className="patientsNoteList mb-0 m-3">
          <ul className="list-group list-group-flush">
            {fetchedNotes.map((items, index) => (
              <li
                className="list-group-item"
                key={index}
                style={{
                  cursor: "pointer",
                }}
              >
                <div className="row mb-0">
                  <div
                    className="col-md-10"
                    onClick={() => {
                      setShowModal(true);
                      setCurrentNoteData(items);
                      setCurrentNoteImages(items.notes);
                    }}
                  >
                    <p className="text-dark font-weight-bold">
                      Dr. {items.doctor_first_name} {items.doctor_last_name}
                    </p>
                    <p className="patientlistDate">
                      {format(new Date(items.created_at), "MMMM dd, yyyy • hh:mm a")}
                    </p>
                  </div>
                  <div className="col-md-2">
                    <span>
                      {items.created_by === getUserData().user && !items.is_locked && (
                        <span className="editIcon">
                          <TemplateIcon
                            type="editIcon"
                            color="var(--icon-color)"
                            onClick={() => {
                              setShowModal(true);
                              setCurrentNoteData(items);
                              setCurrentNoteImages(items.notes);
                              setEditMode(true);
                            }}
                          />
                        </span>
                      )}
                      {items.created_by === getUserData().user && items.is_locked && (
                        <span className="px-2 editIcon">
                          <TemplateIcon
                            type="lock"
                            color="var(--icon-color)"
                            onClick={() => {
                              setCurrentNoteData(items);
                              setCurrentNoteImages(items.notes);
                              setUnlock(items.id);
                            }}
                          />
                        </span>
                      )}
                    </span>
                    {items.created_by === getUserData().user && items.is_locked && (
                      <>
                        <span
                          onClick={() => generatePDF(items)}
                        >
                          <ProfileIcon type="download" className="px-2" />
                        </span>
                        <span
                          onClick={() => {
                            printJS({
                              printable: `<div>
                                <p style="text-align: center; font-weight: bold;">
                                  Appointment Notes with Dr. ${items.doctor_first_name} ${items.doctor_last_name}
                                </p>
                                <p style="text-align: center;">
                                  ${format(new Date(items.created_at), "MMMM dd, yyyy • HH:mm")}
                                </p>
                                <p><strong>Note Name:</strong> ${items.note_name || "-"}</p>
                                <p><strong>Chief Complaints:</strong> ${items.chief_complaint || "-"}</p>
                                <p><strong>Vitals:</strong> Blood Pressure: ${items.blood_pressure || "-"}, Pulse: ${items.pulse || "-"}, 
                                  Oxygen Saturation: ${items.oxygen_saturation || "-"}, Weight: ${items.weight || "-"}, Height: ${items.height || "-"}</p>
                                <p><strong>Notes:</strong> ${items.notes || "-"}</p>
                                <p><strong>Assessments:</strong> ${items.assessment || "-"}</p>
                                <p><strong>Plan:</strong> ${items.plan || "-"}</p>
                                <p><strong>Additional Comment:</strong> ${items.additional_comment || "-"}</p>
                              </div>`,
                              type: "raw-html",
                              documentTitle: "Appointment Notes",
                            });
                          }}
                        >
                          <ProfileIcon type="print" className="px-2" />
                        </span>
                      </>
                    )}
                  </div>
                </div>
                <div className="row mt-0 pt-0">
                  <div className="col-md-8">
                    <p className="text-truncate mb-0">
                      {items.note_name?.replace(/&nbsp;/g, " ")}
                    </p>
                  </div>
                  {items?.last_updated && (
                    <div className="col-md-4">
                      <p className="float-right mb-0 patientlistDate mt-0">
                        Last Updated: {items?.last_updated}
                      </p>
                    </div>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default PatentNoteList;
